import { render, staticRenderFns } from "./LocacaoPage.vue?vue&type=template&id=6f8fa188&"
import script from "./LocacaoPage.vue?vue&type=script&lang=js&"
export * from "./LocacaoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports